<template>
  <div>
    <sub-content-container :title="$t('myInterests.business.title')">
      <interest :interests="completeInterests" />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const Interest = () =>
  import(/* webpackChunkName: "MyInterestsPage" */ "@/components/MyInterests/Interest.vue");

export default {
  name: "Business",
  components: {
    SubContentContainer,
    Interest
  },
  data() {
    return {
      interests: [
        {
          icon: ["fas", "lightbulb"],
          backgroundColor: "black"
        },
        {
          icon: ["fas", "chart-line"]
        }
      ]
    };
  },
  computed: {
    completeInterests() {
      return this.interests.map((data, i) => ({
        ...data,
        ...this.$t("myInterests.business.interests")[i]
      }));
    }
  }
};
</script>
